// extracted by mini-css-extract-plugin
module.exports = {"bkw-G":"G_bkw-G__GmKuy"};